import { useCallback, useState } from "react";
import {
	Box,
	Container,
	Divider,
	Stack,
	Tab,
	Tabs,
	Typography,
} from "@mui/material";
import { PrinterSettings } from "../../components/settings/printer.settings";
import { BillSettings } from "../../components/settings/bill.settings";
import { isRootAdmin, isShopAdmin, useAuthContext } from "../../contexts/auth-context";

const tabs = [
	{ label: "General", value: "general" },
	{ label: "Bill & currency", value: "billing" },
	{ label: "Team", value: "team" },
	{ label: "Notifications", value: "notifications" },
	{ label: "Security", value: "security" },
];

const Page = () => {
	const [currentTab, setCurrentTab] = useState("general");
	const { jwtDecoded } = useAuthContext();
	// Bill settings change what every customer receives: shop admins and root admins only.
	const canEditBills = isShopAdmin(jwtDecoded) || isRootAdmin(jwtDecoded);


	const handleTabsChange = useCallback((event: any, value: any) => {
		setCurrentTab(value);
	}, []);

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					py: 8,
				}}
			>
				<Container maxWidth="xl">
					<Stack spacing={3} sx={{ mb: 3 }}>
						<Typography variant="h4">Settings</Typography>
						<div>
							<Tabs
								indicatorColor="primary"
								onChange={handleTabsChange}
								scrollButtons="auto"
								textColor="primary"
								value={currentTab}
								variant="scrollable"
							>
								{tabs
									.filter((tab) => tab.value !== "billing" || canEditBills)
									.map((tab) => (
										<Tab key={tab.value} label={tab.label} value={tab.value} />
									))}
							</Tabs>
							<Divider />
						</div>
					</Stack>
					{currentTab === "general" && (
						<PrinterSettings />
					)}
					{currentTab === "billing" && canEditBills && <BillSettings />}
					{currentTab === "team" && (
						<>Team</>
					)}
					{currentTab === "notifications" &&
						<>Notification</>}
					{currentTab === "security" && (
						<>Security</>
					)}
				</Container>
			</Box>
		</>
	);
};

// Page.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default Page;
